"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var Arrow = function Arrow(_ref) {
  var className = _ref.className;
  return /*#__PURE__*/_react["default"].createElement("svg", {
    className: className,
    width: "10",
    height: "10",
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M9.22424 7.7161L5.28897 2.29088C5.14611 2.09445 4.8537 2.09445 4.71196 2.29088L0.775579 7.7161C0.765892 7.72944 0.760089 7.74521 0.758813 7.76165C0.757537 7.77809 0.760838 7.79456 0.76835 7.80923C0.775862 7.82391 0.787292 7.83622 0.801373 7.8448C0.815454 7.85338 0.831635 7.85789 0.848123 7.85784H1.68518C1.7421 7.85784 1.79567 7.82994 1.82915 7.78418L4.99991 3.41364L8.17067 7.78418C8.20415 7.82994 8.25772 7.85784 8.31464 7.85784H9.1517C9.22424 7.85784 9.26665 7.77525 9.22424 7.7161Z",
    fill: "currentColor"
  }));
};

var _default = Arrow;
exports["default"] = _default;